import { Inject, Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable()
export class GalleryImagesService {

  constructor(
    @Inject(FormBuilder) private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private form: FormGroup,
  ) { }

  get control(): FormArray {
    return this.form.get('tourMedia')! as FormArray;
  }

  get galleryImages$(): Observable<string[]> {
    return this.control!.valueChanges;
  }

  removeTourMediaDuplicates(): void {
    const fa = this.control;
    const unique = Array.from(new Set(fa.value as string[]));
    fa.clear();
    unique.forEach(v => fa.push(this.fb.control(v)));
  }

  removeImageByIndex(index: number) {
    this.control.removeAt(index);
  }

}
